import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { InvoiceService } from '../../services/invoice/invoice.service';

@Component({
	selector: 'pcm-admin-invoice',
	templateUrl: './admin-invoice.component.html',
	styleUrls: ['./admin-invoice.component.scss']
})
export class AdminInvoiceComponent implements OnInit {

	invoiceData;

	constructor(private invoiceService: InvoiceService
	) { }

	ngOnInit() {
	}

	onSubmit(form: NgForm) {
		console.log('Invoice SUBMIT: ', this.invoiceData);
		this.invoiceService.submitInvoice(this.invoiceData);
	}

}
